(function () {
  const supportedLanguages = ['it', 'de', 'fr', 'en'];
  const defaultLanguage = 'en';

  function getBrowserLanguage() {
    const browserLang = (navigator.language || navigator.userLanguage || 'en')
      .toLowerCase()
      .split('-')[0]; // prende solo "it" da "it-IT", "fr" da "fr-FR" ecc.
    return supportedLanguages.includes(browserLang) ? browserLang : defaultLanguage;
  }

  function setLanguage(langCode) {
    // Trova il form di localizzazione
    const form = document.getElementById('LocalizationForm') 
               || document.getElementById('HeaderLanguageForm');
    if (!form) return;

    const langInput = form.querySelector('[name="language_code"]');
    if (!langInput) return;

    // Se la lingua è già quella giusta, non fare nulla
    if (langInput.value === langCode) return;

    langInput.value = langCode;

    // Invia il form per applicare la lingua
    form.submit();
  }

  // Esegui solo se la lingua attuale non corrisponde a quella del browser
  document.addEventListener('DOMContentLoaded', function () {
    const targetLang = getBrowserLanguage();

    // Leggi la lingua attuale dalla pagina (attributo lang dell'html)
    const currentLang = (document.documentElement.lang || 'en')
      .toLowerCase()
      .split('-')[0];

    if (currentLang !== targetLang) {
      setLanguage(targetLang);
    }
  });
})();
